<template>
  <div class="fukuang">
    <img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/free/slide.png" class="fukuang-top">
    <a href="javascript:;"
      ><img src="../assets/fk1.png" alt="" style="width: 25px;" />
      <p>优师答疑</p>
      <div class="line"></div>
      <span class="zixunhover zixunhover1"
        >微信扫码，免费提问<br />
        <img
          src="https://oss.lingjiang.com/webstatic/questionbank/images/mock-exam/2023/xcx.08842836.jpg"
          style="width: 140px; height: 140px"
        />上领匠问答，<br />给你靠谱回答！</span
      >
    </a>
    <a href="javascript:;"
      ><img src="../assets/fk2.png" alt="" style="width: 35px;" />
      <p>公众号</p>
      <div class="line"></div>
      <span class="zixunhover zixunhover2" style="padding: 5px 0 10px 0;">
        <div class="ewm-item">
          <img src="../assets/ewm.jpg" />
          <p>
            <span class="normal">扫码关注</span>
            <span>高会公众号</span>
          </p>
        </div>
        <div class="ewm-item">
          <img src="../assets/gjewm.jpg" />
          <p>
            <span class="normal">扫码关注</span>
            <span>高经公众号</span>
          </p>
        </div>
      </span>
    </a>
    <a href="javascript:;"
      ><img src="../assets/fk3.png" alt="" style="width: 30px;" />
      <p>下载APP</p>
      <div class="line"></div>
      <span class="zixunhover zixunhover1">
        <img src="../assets/ewm-app.png" style="width: 140px; height: 140px"
      /></span>
    </a>
    <div class="chat" onclick="openchat()"><img src="https://oss.lingjiang.com/webstatic/images/activity/2024/exam/gj/chat.png" alt="" style="width: 30px;" />
      <p>在线客服</p>
      <div class="line"></div></div>
    <div @click="backTop" class="back-top">Top</div>
  </div>
</template>
<script>
export default {
  methods: {
    backTop() {
      //  设置一个定时器
      const upRoll = setInterval(() => {
        const top =
          document.documentElement.scrollTop || document.body.scrollTop; // 每次获取页面被卷去的部分
        const speed = top / 10; // 每次滚动多少 （步长值）
        if (
          document.documentElement.scrollTop !== 0 ||
          document.body.scrollTop !== 0
        ) {
          document.documentElement.scrollTop -= speed;
          document.body.scrollTop -= speed;
          // 不在顶部 每次滚动到的位置
        } else {
          clearInterval(upRoll); // 回到顶部清除定时器
        }
      }, 20);
    }
  }
};
</script>
<style scoped lang="scss">
.fukuang {
  width: 80px;
  height: 381px;
  background: #116af0;
  border-radius: 0 0 6px 6px;
  position: fixed;
  right: 10px;
  top: 50%;
  margin-top: -200px;
  z-index: 12;
  .fukuang-top {
    width: 80px;
    position: absolute;
    top: -62px;
    left: 0;
  }
}

.fukuang a {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 80px;
  height: 70px;
  font-size: 13px;
  margin-bottom: 15px;
  position: relative;
}

.fukuang a img {
  display: block;
}

.fukuang a p {
  line-height: 25px;
  margin: 0;
  padding: 0;
  text-align: center;
}

.fukuang a .zixunhover {
  display: none;
  width: 156px;
  position: absolute;
  background: #fff;
  left: -160px;
  bottom: -100px;
  font-size: 14px;
  color: #666;
  line-height: 120%;
  flex-direction: column;
  text-align: center;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  border: 1px solid #e5e5e5;
  border-radius: 5px;
  padding: 10px 0;
  div {
    line-height: 20px;
  }
}

.fukuang a .zixunhover1 {
  line-height: 20px;
  padding: 14px 10px;
  left: -180px;
  img {
    margin: 4px;
  }
}

.fukuang a .zixunhover img {
  margin-bottom: 5px;
  display: block;
}

.fukuang a:hover {
  background: linear-gradient(
    180deg,
    rgba(253, 153, 29, 1) 0%,
    rgba(235, 103, 95, 1) 100%
  );
}

.fukuang a .zixunhover2 {
  z-index: 10;
  width: 250px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  left: -254px;
  .ewm-item {
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-right: 5px;
      width: 140px;
      height: 140px;
    }
    p {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      span {
        font-size: 16px;
        color: #000;
        line-height: 28px;
      }
      .normal {
        font-size: 15px;
        color: #999;
      }
    }
  }
}

.fukuang a:hover > .zixunhover {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.fukuang .line {
  position: absolute;
  bottom: -1px;
  width: 60px;
  border-top: 1px solid rgba(72, 143, 250, 1);
}
.fukuang .chat {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  width: 80px;
  height: 70px;
  font-size: 13px;
  margin-bottom: 15px;
  position: relative;
  cursor: pointer;
  img {
    display: block;
  }
  p {
    line-height: 25px;
    margin: 0;
    padding: 0;
    text-align: center;
  }

}
.chat:hover {
  background: linear-gradient(
    180deg,
    rgba(253, 153, 29, 1) 0%,
    rgba(235, 103, 95, 1) 100%
  );
}
.fukuang .back-top {
  margin: 0 auto;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/sidenav.vue